export default __webpack_public_path__ + "static/media/2.20b4bb53.png";